import { Tooltip } from '@mui/material';

import { Tag } from '@/components/tag';
import { dataClassLabel } from '@/data/inventory/dataClassifications';
import { useClassificationCategories } from '@/data/inventory/useClassificationCategories';

export function DataClassTag({ name }: { name: string }) {
  const { lookup } = useClassificationCategories();
  return (
    <Tooltip title={lookup[name]?.description ?? lookup[name]?.title ?? name}>
      <Tag content={dataClassLabel(name)} />
    </Tooltip>
  );
}
